import { BRANDS_SECTION } from '@/features/settingsPage/consts/sections';
import { getSectionUrl } from '@/features/settingsPage/structs/section';

export { RESOURCE_NAME } from '@esentai/core/features/brands/consts';

export const ROUTE_PATH = getSectionUrl(BRANDS_SECTION);

export const FEATURE_NAME = 'brandsPage';
